@if (station()) {
  <div class="is-flex is-space-between">
    <div class="is-flex is-column gap-8 is-justify-space-around is-flex-grow-1">
      <app-text class="text-14 is-family-semiBold">{{ 'app.__TYPE_RAIN' | AsyncLang | async }}</app-text>
      <div class="is-flex">
        <div class="rain-data is-flex is-column gap-4">
          <app-text class="text-12 is-family-medium">{{ 'app.__RAIN_1H' | AsyncLang | async }}</app-text>
          <div class="is-flex is-align-baseline gap-4">
            <app-text class="text-blue text-18 is-family-medium">{{ rainLastHour() | toUserUnit: type | toDisplayValue: type}}</app-text>
            <app-text class="text-16 is-family-semiBold text-grey-50" unit [measureType]="type" />
          </div>
        </div>
        <div class="rain-data is-flex is-column gap-4">
          <app-text class="text-12 is-family-medium">{{ 'app.__RAIN_24H' | AsyncLang | async }}</app-text>
          <div class="is-flex is-align-baseline gap-4">
            <app-text class="text-blue text-18 is-family-medium">{{ rainToday() | toUserUnit: type | toDisplayValue: type }}</app-text>
            <app-text class="text-16 is-family-semiBold text-grey-50" unit [measureType]="type" />
          </div>
        </div>

        <app-rain-icon [rainLastHour]="rainLastHour()"/>
      </div>
    </div>
  </div>
}
